import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    {
      path: '*',
      name: '404',
      component: () => import('../views/error/errorPage.vue')
    },
    { path: '/', redirect: '/index' },
    { path: '/index', component: () => import('../views/home/home.vue') },
    { path: '/spb', component: () => import('../views/home/spellingBee.vue') },
    { path: '/individual', component: () => import('../views/home/individual.vue') },
    { path: '/itso', component: () => import('../views/home/itso.vue') },
    { path: '/cebsb', component: () => import('../views/home/cebsb.vue') },
    { path: '/aisb', component: () => import('../views/home/aisb.vue') },
    { path: '/challenge', component: () => import('../views/home/challenge.vue') },
    { path: '/spbcn-cer', component: () => import('../views/certificate/spbcn-cer.vue') },
    { path: '/itso-cer', component: () => import('../views/certificate/itso-cer.vue') },
    // { path: '/test', component: () => import('../views/home/test.vue') },

  ]
})

// 挂载导航路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  } else {
    document.title = 'SPBCN | Spelling Bee of China'
  }
  // const whiteList = [
  //   '/login',
  // ]
  // if (whiteList.includes(to.path)) return next()
  // if (!localStorage.getItem('Authorization')) return next('/login')
  next()
})

export default router
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}